/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { WorkflowStageTaskViewModel } from './WorkflowStageTaskViewModel'; 

export function getWorkflowStageTaskByNameAndCorrelatorOptions(correlationId: string, workflowStageTaskName: string, onSuccess?: (result: WorkflowStageTaskViewModel) => void) {
	return queryOptions({
		queryKey: ['workflow-stage-task-by-name-and-correlator', correlationId, workflowStageTaskName],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/workflows/queries/getworkflowstagetaskbynameandcorrelator/' + correlationId + '/' + workflowStageTaskName;
			const resp = await axios.get<WorkflowStageTaskViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(correlationId) && Boolean(workflowStageTaskName)
	});
}